import { createContext as E, use as i, useCallback as d, useEffect as h, useRef as v } from "react";
import { jsx as f } from "react/jsx-runtime";
var o = E(null);
o.displayName = "EventBusContext";
var B = ({ children: e, target: t }) => {
  const r = v(t || new EventTarget()), s = v(/* @__PURE__ */ new Map()), n = d((a, c) => {
    s.current.set(a, c), r.current.dispatchEvent(new CustomEvent(a, { detail: c }));
  }, []), u = {
    target: r.current,
    cacheRef: s,
    dispatch: n
  };
  return /* @__PURE__ */ f(o, {
    value: u,
    children: e
  });
}, l = (e, t, r) => {
  const s = i(o);
  if (!s) throw new Error("useEventBus must be used within an EventBusProvider");
  const { target: n, cacheRef: u } = s;
  h(() => {
    const a = (c) => {
      t(c.detail);
    };
    return n.addEventListener(e, a), r?.replayLast && u.current.has(e) && t(u.current.get(e)), () => {
      n.removeEventListener(e, a);
    };
  }, [
    e,
    t,
    r?.replayLast,
    n,
    u
  ]);
}, x = () => {
  const e = i(o);
  if (!e) throw new Error("useEventBusDispatcher must be used within an EventBusProvider");
  return e.dispatch;
};
export {
  B as EventBusProvider,
  l as useEventBus,
  x as useEventBusDispatcher
};

//# sourceMappingURL=EventBusProvider.js.map